import axios from 'axios';

const BASE_URL = '/app/dealFunnel';

export const getDealConfiguration = async () => {
    const { data } = await axios.get(`${BASE_URL}/config`);

    return data;
};
